// extracted by mini-css-extract-plugin
export default {"wrapper":"image_wrapper__U0jU2","img":"image_img__oBcoU","skeleton":"image_skeleton__yG9fr"};